module.exports = __webpack_public_path__ + "media/images/vector-17@2x-c2e82bb84fd35b04c6959b376f42a88f.png";